<template>
  <v-app>
    <v-main>
      <general-tools-global-card v-show="$store.state.authenticated && !!this.$route.params.app"></general-tools-global-card>
      <general-tools-global></general-tools-global>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import GeneralToolsGlobal from "@/views/Tools/Global/GeneralToolsGlobal";
import GeneralToolsGlobalCard from "@/views/Tools/Global/GeneralToolsGlobalCard";

export default {
  name: 'App',
  components: {
    GeneralToolsGlobal,
    GeneralToolsGlobalCard,
  },
  data: () => ({}),
};
</script>
